<div [@WindowOpenClose]="windowVisible.getValue() ? 'visible' : 'invisible'" (click)="windowClick()">
  <dialog-header [label]="'SETTINGS.PLOT_SETTINGS' | translate" [dialogRef]='dialogRef' [object]='this'></dialog-header>
  <mat-card class="display-settings">
    <div class="plot-display-box">
      <mat-radio-group fxLayoutGap="8px" (change)="onPlotDisplayRadioChanged($event)" [value]="plotDisplaySymbol">
        <mat-radio-button value='symbol'>{{'PLOTSETTINGS.SYMBOL' | translate}}</mat-radio-button>
        <mat-radio-button value='letter'>{{'PLOTSETTINGS.CHARACTER' | translate}}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div class="slider-with-label" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="8px">
      <span>{{('PLOTSETTINGS.TRAIL' | translate)}}&nbsp;&nbsp;{{('PLOTSETTINGS.LENGTH' | translate)}}</span>
      <mat-slider fxFlex="grow" thumbLabel tickInterval="{{plotTrailMaxLength() / 10}}" step="1" min="0"
        max="{{plotTrailMaxLength()}}" [value]="plotTrailLength" (change)="onPlotTrailSliderChanged($event)">
      </mat-slider>
    </div>
  </mat-card>
</div>